import { alpha, darken, getContrastRatio, lighten } from '@mui/material/styles'

export type MenuTemaModo = 'dark' | 'light'

const HEX_COLOR_REGEX = /^#[0-9A-Fa-f]{6}$/

export const DEFAULT_MENU_TEMA_MODO: MenuTemaModo = 'dark'
export const DEFAULT_MENU_COLOR_PRINCIPAL = '#FF3030'

export const normalizeMenuTemaModo = (value?: string | null): MenuTemaModo =>
    value === 'light' || value === 'dark' ? value : DEFAULT_MENU_TEMA_MODO

export const normalizeMenuColorPrincipal = (value?: string | null): string => {
    if (!value) {
        return DEFAULT_MENU_COLOR_PRINCIPAL
    }

    const hex = value.startsWith('#') ? value : `#${value}`
    return HEX_COLOR_REGEX.test(hex) ? hex.toUpperCase() : DEFAULT_MENU_COLOR_PRINCIPAL
}

export const buildPrimaryPaletteFromHex = (hex: string) => {
    const main = normalizeMenuColorPrincipal(hex)
    const contrastText = getContrastRatio(main, '#FFFFFF') >= 3 ? '#FFFFFF' : '#161C24'

    return {
        lighter: lighten(main, 0.72),
        light: lighten(main, 0.36),
        main,
        dark: darken(main, 0.24),
        darker: darken(main, 0.48),
        contrastText,
    }
}

export const buildPrimaryShadow = (main: string) => `0 8px 16px 0 ${alpha(main, 0.24)}`
